import { useState } from 'react';
import { TriangleAlert, MessageSquare, Lightbulb, Check } from 'lucide-react';
import nhost from '../nhost';

const TYPES = [
  { key: 'bug',        label: 'Problem',  Icon: TriangleAlert, color: '#a32d2d',      bg: '#fcebeb' },
  { key: 'feedback',   label: 'Feedback', Icon: MessageSquare, color: 'var(--wine)',   bg: 'var(--wine-light)' },
  { key: 'suggestion', label: 'Förslag',  Icon: Lightbulb,     color: '#A07830',       bg: 'var(--gold-light)' },
];

export default function FeedbackModal({ profile, onClose }) {
  const [type, setType] = useState('feedback');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);
  const [sent, setSent] = useState(false);

  async function send() {
    if (!message.trim()) { alert('Skriv ett meddelande'); return; }
    setSaving(true);
    await nhost.graphql.request(`
      mutation SendFeedback($user_id: uuid!, $type: String!, $message: String!) {
        insert_feedback_one(object: { user_id: $user_id, type: $type, message: $message }) { id }
      }
    `, { user_id: profile.id, type, message: message.trim() });
    try {
      await fetch('/api/notify-feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, message: message.trim(), displayName: profile.display_name || 'Okänd användare' }),
      });
    } catch (err) { console.error('Failed to notify admin', err); }
    setSaving(false);
    setSent(true);
  }

  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-handle" />
        <div className="modal-title">Feedback & förslag</div>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--teal-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
              <Check size={26} color="var(--teal)" strokeWidth={2.2} />
            </div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 600, color: 'var(--ink)', marginBottom: 6 }}>Tack för din feedback!</div>
            <div style={{ fontSize: 13, color: 'var(--muted)' }}>Admin kommer att läsa ditt meddelande.</div>
            <button onClick={onClose} style={{ marginTop: 20, background: 'var(--wine)', color: '#fff', border: 'none', borderRadius: 12, padding: '11px 28px', fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit' }}>
              Stäng
            </button>
          </div>
        ) : (
          <>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 14, lineHeight: 1.5 }}>
              Hittade du ett problem, har feedback på appen eller en idé? Berätta!
            </div>

            {/* Typval */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              {TYPES.map(({ key, label, Icon, color, bg }) => (
                <button
                  key={key}
                  onClick={() => setType(key)}
                  style={{
                    flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
                    padding: '12px 6px', borderRadius: 12, cursor: 'pointer',
                    border: `1.5px solid ${type === key ? color : 'rgba(60,20,30,.12)'}`,
                    background: type === key ? bg : 'white',
                    color: type === key ? color : 'var(--muted)',
                    fontFamily: 'inherit',
                    transition: 'all .15s',
                  }}
                >
                  <Icon size={18} strokeWidth={1.8} />
                  <span style={{ fontSize: 12, fontWeight: type === key ? 600 : 400 }}>{label}</span>
                </button>
              ))}
            </div>

            {/* Meddelande */}
            <div className="field">
              <label>Meddelande</label>
              <textarea
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder={
                  type === 'bug' ? 'Beskriv problemet du stött på...' :
                  type === 'suggestion' ? 'Beskriv din idé eller förbättring...' :
                  'Dela din feedback om appen...'
                }
                style={{ minHeight: 120, borderRadius: 12, border: '1px solid rgba(139,42,62,.2)', resize: 'vertical' }}
              />
            </div>

            <div className="btn-row">
              <button className="btn-secondary" onClick={onClose}>Avbryt</button>
              <button className="btn-primary" onClick={send} disabled={saving}>
                {saving ? 'Skickar...' : 'Skicka'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
